import '../../styles/Home.scss';
import stand from '../../assets/images/Stand A Chance To WIN@2x.jpg';
import logo from '../../assets/images/safari-logo.svg'
import {Link} from "react-router-dom";

function CompetitionTerms() {
    return (
        <div className="competition-terms">
            <img src={stand} alt="Competition Banner" />

            <div className="terms-body">
                <p className="p1">
                    <span style={{ textDecoration: 'underline' }}>
                        <b>Safari 2026 Competition Terms and Conditions</b>
                    </span>
                </p>

                <ol>
                    <li>
                        Introduction – Safari
                        <ol
                            style={{
                                listStyleType: 'none',
                                paddingLeft: '20px'
                            }}
                        >
                            <li style={{ marginBottom: '10px' }}>
                                1.1 Participation in this Competition is governed by these terms and conditions (the <strong>“Rules”</strong>).
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                1.2 Participants are encouraged to review the Rules before entering into the Competition and acknowledge that they have been given an appropriate opportunity to do so and that they understand and accept these Rules.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                1.3 This competition is operated by Safari (South Africa) (“Promoter”).
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                1.4 Participation in the Competition constitutes acceptance of these Rules and Participants agree to abide by these Rules.
                            </li>
                        </ol>
                    </li>

                    <li>
                        By participating in this Competition, Participants agree to the rules set out below.
                        <ol
                            style={{
                                listStyleType: 'none',
                                paddingLeft: '20px'
                            }}
                        >
                            <li style={{ marginBottom: '10px' }}>
                                2.1 This Competition is limited to legal residents of South Africa <strong>only</strong>. Entrants that have a legal SA working permit are eligible to enter the competition. Valid Passports of legal SA residents will be permitted. In addition, the following people shall not be eligible to participate in this Competition.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                2.2 Directors, members, partners, promotional and advertising agents, merchandisers, employees or consultants of the Promoters.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                2.3 People who are not legal residents and/or legal citizens of the Republic of South Africa.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                2.4 Spouse, life partner, parent, child, brother, sister, business partner or associate of any of the persons specified above.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                2.5 Persons under the age of 18 years.
                            </li>
                        </ol>
                    </li>

                    <li>
                        Mechanics:
                        <ol
                            style={{
                                listStyleType: 'none',
                                paddingLeft: '20px'
                            }}
                        >
                            <li style={{ marginBottom: '10px' }}>
                                To participate in this Competition, Participants must adhere to the following:
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                3.1 Buy any Safari Vinegar product, dial *120*1531# and follow the prompts. Keep proof of purchase (receipt/till slip) to be able to redeem your prize.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                3.2 Each entry via USSD costs the user 20c/20 seconds and an entry should be completed within 60 seconds maximum.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                3.3 Standard network charges apply, and the participant is responsible for having sufficient airtime and network coverage to complete an entry.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                3.4 Till slip needs to be within the current competition dates period.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                3.5 The Competition will open on September 01 2026 at 00:00:01 and close on November 30 2026 at 23:59:59 (“promotional period”). No late entries will be accepted.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                3.6 Participating products mean:
                            </li>
                        </ol>

                        <ol
                            style={{
                                paddingLeft: '20px',
                                listStyleType: 'none'
                            }}
                        >
                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                1. STOCK CODE: SP05W1LSAF<br />
                                VARIANT: WHITE SPIRIT VINEGAR<br />
                                PACKAGING: 1L<br />
                                UNIT BC: 6001052014056
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                2. STOCK CODE: SP05B1LSAF<br />
                                VARIANT: BROWN SPIRIT VINEGAR<br />
                                PACKAGING: 1L<br />
                                UNIT BC: 6001052014049
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                3. STOCK CODE: SP05B750SAF<br />
                                VARIANT: BROWN GRAPE VINEGAR<br />
                                PACKAGING: 750 ml<br />
                                UNIT BC: 6001020020331
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                4. STOCK CODE: GR05W750SAF<br />
                                VARIANT: WHITE GRAPE VINEGAR<br />
                                PACKAGING: 750 ml<br />
                                UNIT BC: 6001020020324
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                5. STOCK CODE: MA05W375X12SAF<br />
                                VARIANT: WHITE MALT VINEGAR<br />
                                PACKAGING: 375 ml<br />
                                UNIT BC: 6001222500105
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                6. STOCK CODE: RC05N375X12SAF<br />
                                VARIANT: RICE VINEGAR<br />
                                PACKAGING: 375 ml<br />
                                UNIT BC: 6001222500099
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                7. STOCK CODE: AP05N500SAFORG<br />
                                VARIANT: ORGANIC APPLE CIDER VINEGAR<br />
                                PACKAGING: 500 ml<br />
                                UNIT BC: 6001052012816
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                8. STOCK CODE: AP05N500SAFORGHG<br />
                                VARIANT: ORGANIC APPLE CIDER VINEGAR WITH HONEY &amp; GINGER<br />
                                PACKAGING: 500 ml<br />
                                UNIT BC: 6001052012809
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                9. STOCK CODE: AP05N375SAFU<br />
                                VARIANT: APPLE CIDER VINEGAR UNFILTERED WITH THE “MOTHER”<br />
                                PACKAGING: 375 ml<br />
                                UNIT BC: 6001052012458
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                10. STOCK CODE: AP05N375SAF<br />
                                VARIANT: APPLE CIDER VINEGAR FILTERED<br />
                                PACKAGING: 375 ml<br />
                                UNIT BC: 6001020020195
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                11. STOCK CODE: WN06R500SAFL<br />
                                VARIANT: RED WINE VINEGAR<br />
                                PACKAGING: 500 ml<br />
                                UNIT BC: 6001052013899
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                12. STOCK CODE: WN06W500SAFL<br />
                                VARIANT: WHITE WINE VINEGAR<br />
                                PACKAGING: 500 ml<br />
                                UNIT BC: 6001052013905
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                13. STOCK CODE: BA500SAFBRN<br />
                                VARIANT: CAPE BLACK BALSAMIC VINEGAR<br />
                                PACKAGING: 500 ml<br />
                                UNIT BC: 6001052012755
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                14. STOCK CODE: BA500SAFAPP<br />
                                VARIANT: CAPE APPLE BALSAMIC VINEGAR<br />
                                PACKAGING: 500 ml<br />
                                UNIT BC: 6001052012748
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                15. STOCK CODE: SAF150AHBG<br />
                                VARIANT: CAPE APPLE BALSAMIC GLAZE<br />
                                PACKAGING: 150 ml<br />
                                UNIT BC: 6001052013042
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                16. STOCK CODE: SAF150JBG<br />
                                VARIANT: JALAPENO BALSAMIC GLAZE<br />
                                PACKAGING: 150 ml<br />
                                UNIT BC: 6001052013073
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                17. STOCK CODE: SAF150SPBG<br />
                                VARIANT: SWEET PEPPER BALSAMIC GLAZE<br />
                                PACKAGING: 150 ml<br />
                                UNIT BC: 6001052013035
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                18. STOCK CODE: SAF150BBG<br />
                                VARIANT: CAPE BLACK BALSAMIC GLAZE<br />
                                PACKAGING: 150 ml<br />
                                UNIT BC: 6001052013059
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                19. STOCK CODE: SP05W6X2SAF<br />
                                VARIANT: 5% SAFARI WHITE SPIRIT VINEGAR<br />
                                PACKAGING: 2L<br />
                                UNIT BC: 6001020020270
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                20. STOCK CODE: SP05B6X2SAF<br />
                                VARIANT: 5% SAFARI BROWN SPIRIT VINEGAR<br />
                                PACKAGING: 2L<br />
                                UNIT BC: 6001020020577
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                21. STOCK CODE: SP05W2X5SAF<br />
                                VARIANT: 5% SAFARI WHITE SPIRIT VINEGAR<br />
                                PACKAGING: 5L<br />
                                UNIT BC: 6001020020287
                            </li>

                            <li style={{ lineHeight: '1.2', marginBottom: '20px' }}>
                                22. STOCK CODE: SP05B2X5SAF<br />
                                VARIANT: 5% SAFARI BROWN SPIRIT VINEGAR<br />
                                PACKAGING: 5L<br />
                                UNIT BC: 6001020020584
                            </li>
                        </ol>

                        <ol
                            style={{
                                listStyleType: 'none',
                                paddingLeft: '20px'
                            }}
                        >
                            <li style={{ marginBottom: '10px' }}>
                                3.7 Winners of prizes will be determined by random draw which will be held on a scheduled basis during the campaign period. Please refer to section 4 for more detail on these.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                3.8 The Promoter is not liable for the failure of any technical element relating to this promotional competition that may result in an entry not being successfully submitted.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                3.9 Participants may enter the competition a maximum of [3] times per person per week over the promotional period, provided that Participants purchase a participating product each time and complete the competition entry and enter a barcode and if requested, provide a till slip, as proof of purchase, subject to the following conditions:
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                3.10 All entries from disqualified participants’ mobile numbers will be rejected.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                3.11 A person can only win a prize once.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                3.12 No computer-based entries will be accepted. Only humans can enter and no robots.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                3.13 Participants that are drawn as potential winners will need to provide a valid till slip showing proof of purchase of participating products from participating retailers within campaign period.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                3.14 The till slip provided must be dated/timestamped prior to the Participants’ entry otherwise the entry will be null and void.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                3.15 A Participant must provide proof of purchase per entry in order to claim a prize. For example, if a Participant’s 5th entry is drawn as a potential winner, the Participant must provide five valid till slips which are all time/date stamped prior to their entries.
                            </li>
                        </ol>
                    </li>

                    <li>
                        The Prizes:
                        <ol
                            style={{
                                listStyleType: 'none',
                                paddingLeft: '20px'
                            }}
                        >
                            <li style={{ marginBottom: '10px' }}>
                                4.1 Valid participants in this Competition stand a chance to win 1 of 100 R1,000 cash prizes.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                4.2 Draw Dates:
                                <ul
                                    style={{
                                        listStyleType: 'disc',
                                        paddingLeft: '20px'
                                    }}
                                >
                                    <li>10th September 2026 x8 winners</li>
                                    <li>17th September 2026 x8 winners</li>
                                    <li>24th September 2026 x8 winners</li>
                                    <li>01st October 2026 x8 winners</li>
                                    <li>08th October 2026 x8 winners</li>
                                    <li>15th October 2026 x8 winners</li>
                                    <li>22nd October 2026 x8 winners</li>
                                    <li>29th October 2026 x8 winners</li>
                                    <li>05th November 2026 x8 winners</li>
                                    <li>12th November 2026 x7 winners</li>
                                    <li>19th November 2026 x7 winners</li>
                                    <li>26th November 2026 x7 winners</li>
                                    <li>03rd December 2026 x7 winners</li>
                                </ul>
                            </li>
                        </ol>
                    </li>

                    <li>
                        How to claim your prizes:
                        <ol
                            style={{
                                listStyleType: 'none',
                                paddingLeft: '20px'
                            }}
                        >
                            <li style={{ marginBottom: '10px' }}>
                                5.1 The potential prize winners are not an actual winner until his/her submission is validated and his/her documents are completed and submitted to the Promoters. If a potential prize winner does not meet the eligibility requirements, the prize will be forfeited and a runner up finalist will be deemed the potential prize winner subject to the terms and conditions herein. Valid till slips will be requested from potential winners and must be provided within the period set out in clause 5.7. Failure to provide a valid till slip within that period will result in the individual forfeiting the prize.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                5.2 If the representatives are unable to reach any of the potential prize winners after 3 (three) attempts made within 3 (three) working days of their name being drawn, for whatsoever reason, including incorrect telephone numbers or inoperative telephone numbers, such winner will be disqualified and a runner up finalist will be deemed the potential prize winner subject to the terms and conditions herein.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                5.3 The prize is a cash prize and will be paid by one of the following methods, as determined by the Promoter in its sole discretion after consultation with the verified winner:
                                <ol
                                    style={{
                                        listStyleType: 'none',
                                        paddingLeft: '20px'
                                    }}
                                >
                                    <li style={{ marginBottom: '10px' }}>
                                        5.3.1 electronic funds transfer (“EFT”) into a bank account held at a South African registered bank in the verified winner’s own name; or
                                    </li>

                                    <li style={{ marginBottom: '10px' }}>
                                        5.3.2 a mobile cash transfer (“Mobile Cash Transfer”) sent to the mobile number from which the winning entry was submitted, such as a cash send service offered by a South African registered bank and redeemable at that bank’s automated teller machines and participating outlets.
                                    </li>
                                </ol>
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                5.4 No prize will be paid into an account, or sent to a mobile number, held or registered in the name of any third party.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                5.5 Where payment is to be made by EFT, the verified winner must provide the Promoter with: (a) their full name and South African identity number, or passport number in the case of a non-citizen entitled to enter under clause 2.1; (b) the banking details of an account held in their own name; and (c) confirmation of those banking details in the form of a bank confirmation letter or a bank-stamped statement issued within the preceding three months. The Promoter may decline to make payment until the name on the account has been verified as that of the winner.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                5.6 Where payment is to be made by Mobile Cash Transfer, the verified winner must provide the Promoter with their full name and South African identity number, or passport number in the case of a non-citizen entitled to enter under clause 2.1, and must confirm that the mobile number from which the winning entry was submitted is registered to them and is in their possession. The Promoter may require proof that the number is registered in the winner’s name before making payment.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                5.7 A potential prize winner must provide the Promoter with a valid till slip in accordance with clause 3, together with the documents and confirmations set out in clauses 5.5 or 5.6 as applicable, within 48 (forty-eight) hours of the Promoter first making successful contact with them. Should a potential prize winner fail to do so, the prize will be forfeited and a runner up finalist will be deemed the potential prize winner, subject to these Rules. The Promoter may, in its sole discretion, extend this period where a potential prize winner is prevented from complying by circumstances beyond their reasonable control.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                5.8 Payment will be made within 15 (fifteen) business days after the Promoter has received and verified all documents and confirmations required under clause 5.7. Any bank, network or transaction charges levied by the winner’s own bank or mobile network operator, and any charge levied for withdrawal of a Mobile Cash Transfer, are for the winner’s account.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                5.9 The winner is responsible for the accuracy of the banking details and mobile number they provide and for the security of the redemption details sent to them. The Promoter will have no liability, and the winner will have no claim of any nature against the Promoter, where a prize is paid into an account or to a mobile number nominated or used by the winner, including where the details supplied were incorrect or incomplete, where the redemption notification was not received owing to network, handset or software failure, or where the redemption details were disclosed to or used by any other person.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                5.10 A Mobile Cash Transfer must be redeemed within the period stipulated by the issuing bank, and in any event within 30 (thirty) days of the date on which it is sent. Where a Mobile Cash Transfer is not redeemed within that period, or where an EFT payment is returned unpaid, the Promoter will make one further payment attempt after the winner has supplied corrected details. If the prize remains unredeemed or unpaid 30 (thirty) days after that further attempt, it will be forfeited and the Promoter will have no further obligation in respect of it.
                            </li>
                        </ol>
                    </li>

                    <li>
                        General
                        <ol
                            style={{
                                listStyleType: 'none',
                                paddingLeft: '20px'
                            }}
                        >
                            <li style={{ marginBottom: '10px' }}>
                                6.1 The judges’ decision is final, and no correspondence will be entered into.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                6.2 The Promoters may require the winner to complete and submit an information disclosure agreement to enable the Promoters to ensure compliance with these Rules. Should the winner be found, in the Promoters sole discretion: not to be eligible to win; not to have complied with these Rules; their conduct can be reasonably interpreted as scamming; acted fraudulently with regards to the Competition; and if it would be unlawful to award the prize, he/she will automatically be disqualified and/or the prize will be forfeited. Winners may also be required to sign acceptance of prizes and indemnity documents.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                6.3 The prize is not transferable, and no substitution or cash redemption of prizes is permitted. The prize will not be handed/awarded to a third party, but only to the verified prize winner.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                6.4 The Promoters reserve the right, at their sole discretion, to substitute the prize with any other prize of comparable or greater commercial value for whatever reason.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                6.5 By entering, a Participant acknowledges that personal information about the Participant will be shared with the Promoters and their agents to the extent necessary to conduct the Competition and for prizes to be delivered to prize winners.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                6.6 By entering this Competition you authorise the Promoters to collect, store and use (for the purposes of fulfilling promotional related activities only) personal information of Participants for communication or statistical purposes. You are entitled to decline any marketing communication by opting out to receiving future communication from the brand when asked for opt-in during the first entry. Alternatively, you may respond STOP to any future correspondence from the brand and the Participants’ number will be deleted from the database. Any personal data submitted by you will be used solely in accordance with current South African data protection legislation and Safari privacy policy.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                6.7 Participants may be required to take part in publicity campaigns for broadcast or publishing purposes. Participants shall at all times be entitled to decline the above request. Participants that take part in any publicity will not be entitled to any payment or other remuneration for such publicity or otherwise. All publicity and other materials will be the sole property of the Promoters.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                6.8 Nothing in these Rules is intended to, or must be understood to, unlawfully restrict, limit or avoid any rights or obligations, as the case may be, created for either the Participant or the Promoters in terms of the Consumer Protection Act, 68 of 2008 ("CPA").
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                6.9 The Participant, by entering into the Promotional Competition, expressly acknowledges that he/she has been given an appropriate opportunity to first read the Competition Rules before entering the Promotional Competition and that he/she understands and thereby agrees to the Competition Rules.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                6.10 By entering into the Promotional Competition, the Participant expressly agrees to the following indemnifications:
                                <ol
                                    style={{
                                        listStyleType: 'none',
                                        paddingLeft: '20px'
                                    }}
                                >
                                    <li style={{ marginBottom: '10px' }}>
                                        6.10.1 the Participant indemnifies and holds harmless the Promoter and its promotional partners, their employees and their agents (“the Indemnified Parties”) of any and all liability pertaining to any damage, cost, injuries and losses of whatsoever nature and howsoever arising as a result of their participation in the Promotional Competition and related events and activities, including, without limitation, personal injuries, death, and property damage, and claims based on publicity rights, defamation or invasion of privacy; and
                                    </li>

                                    <li style={{ marginBottom: '10px' }}>
                                        6.10.2 the Participant accepts that the Indemnified Parties will not be responsible for any costs, damage or otherwise, howsoever incurred by the Winner subsequent to claiming the Prize.
                                    </li>
                                </ol>
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                6.11 All Participants participate entirely at their own risk. By reading and accepting these Rules, the Participants give consent to these risks and hereby indemnifies and holds harmless the Promoters, their directors, employees and agents of any and all liability pertaining to any damage, cost, injuries and losses of whatever nature sustained as a result of their participation in the Competition and related events and activities, save where such damage, cost, injuries and losses are sustained as a result of the gross negligence or wilful misconduct of any of the Promoters.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                6.12 The Promoters, their directors, employees, agents and distributors accept no responsibility and they will not, in any circumstances, be liable to compensate the Participants, or accept any liability for: (a) any inability by the Participant to use the prize in part or at all; (b) the lack of quality or any other aspect of any service which is or should be provided at any venue(s) in relation to the prize; or (c) any personal loss or injury occurring at any venue(s) arising, directly or indirectly, out of the use of the prize.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                6.13 The Promoters, their directors, employees, agents and distributors, are not responsible for any misrepresentation (whether written or verbal) in respect of any prize nor in respect of any warranties or undertakings given by any person other than the Promoters themselves.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                6.14 The Promoters reserve the right to terminate or extend the Competition at any time. In the event of such termination or extension, all Participants agree to waive (give up) any rights that they may have in terms of the Competition and acknowledge that they will have no recourse against the Promoters, their advertising agencies, advisors, suppliers and nominated agents.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                6.15 By entering the Competition, Participants acknowledge that the Competition will be managed in accordance with the provisions of the CPA. Participants undertake to expeditiously do all things necessary to enable the Promoters to comply with their obligations under the CPA including, but not limited to providing such personal information as may be required in order to facilitate handing over the prize to the Participant. Should any Participant refuse or be unable to comply with this requirement, the Participant shall be deemed to have forfeited the prize.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                6.16 Notwithstanding anything to the contrary contained in these Rules, the Promoters reserve the right to amend, modify, change, postpone suspend or cancel this Competition, the Rules and any prize (which has not yet been allocated), or any aspect thereof, without notice at any time, for any reason which the Promoters deem necessary. At the end of the Competition for whatsoever reason, all of the Promoters’ obligations in regard to the Competition as well as in regard to the prizes shall cease to exist.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                6.17 These Rules shall be governed by and interpreted according to the laws of the Republic of South Africa and any Participant and Safari consent to the non-exclusive jurisdiction of the High Court of South Africa.
                            </li>

                            <li style={{ marginBottom: '10px' }}>
                                6.18 This Promotional Competition is in no way sponsored, endorsed or administered by, or associated with, Facebook, Twitter or any other Social Network.
                            </li>
                        </ol>
                    </li>
                </ol>
            </div>
        </div>
    );
}

export default CompetitionTerms;
